/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wie ein Ja/Nein-Feld aussieht.
 * 
 *   VALUES_WITH_TOGGLE_LOOK — beide Texte mit Schalter dazwischen.
 *   TOGGLE_ONLY_LOOK        — nur der Schalter.
 *   VALUE_ONLY_LOOK         — Schalter und der zutreffende Text.
 *   CHECKBOX_LOOK           — ein HAEKCHEN mit dem Text daneben.
 *                             Vorgabe des Betreibers vom 15.09.2026:
 *                             „Ja/Nein ist aber kein Toggle sondern eine
 *                             Checkbox." Fuer Einwilligungen ist das
 *                             Haekchen die uebliche und erwartete Form —
 *                             ein Schalter sieht nach Einstellung aus,
 *                             nicht nach Zustimmung.
 * @export
 */
export const DatabaseYesNoFieldLook = {
    ValuesWithToggleLook: 'VALUES_WITH_TOGGLE_LOOK',
    ToggleOnlyLook: 'TOGGLE_ONLY_LOOK',
    ValueOnlyLook: 'VALUE_ONLY_LOOK',
    CheckboxLook: 'CHECKBOX_LOOK'
} as const;
export type DatabaseYesNoFieldLook = typeof DatabaseYesNoFieldLook[keyof typeof DatabaseYesNoFieldLook];


export function DatabaseYesNoFieldLookFromJSON(json: any): DatabaseYesNoFieldLook {
    return DatabaseYesNoFieldLookFromJSONTyped(json, false);
}

export function DatabaseYesNoFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseYesNoFieldLook {
    return json as DatabaseYesNoFieldLook;
}

export function DatabaseYesNoFieldLookToJSON(value?: DatabaseYesNoFieldLook | null): any {
    return value as any;
}

